export default __webpack_public_path__ + "static/media/grafema_martini-contest_03.98a589b3.jpg";